module.exports = TabVisibility;

function TabVisibility(opts) {
	let visible = true;

	let stateKey, eventKey, keys = {
		hidden: "visibilitychange",
		webkitHidden: "webkitvisibilitychange",
		mozHidden: "mozvisibilitychange",
		msHidden: "msvisibilitychange"
	};

	for (stateKey in keys) {
		if (stateKey in document) {
			eventKey = keys[stateKey];
			break;
		}
	}

	if(!eventKey) return;

	if(opts.parent) {
		opts.parent.visible = !document[stateKey];
	}

	document.addEventListener(eventKey, () => {
		visible = !document[stateKey];
		
		if(opts.parent) {
			opts.parent.visible = !document[stateKey];
		}

		if(opts.callback) {
			opts.callback();
		}
	});

	this.isVisible = function() {
		return visible;
	}
}